'use client';

import { type ReactNode } from 'react';
import { CloseButton, Divider, Modal } from '@zillow/constellation-10';
import { drawerRecipe } from './drawer.styles';

export type DrawerPlacement = 'start' | 'end';
export type DrawerSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'fullScreen';

export type DrawerProps = {
  id?: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  ariaLabel: string;
  children: ReactNode;
  closeLabel?: string;
  placement?: DrawerPlacement;
  size?: DrawerSize;
  header?: ReactNode;
  footer?: ReactNode;
  dividers?: boolean;
};

export default function Drawer({
  id,
  open,
  onOpenChange,
  ariaLabel,
  children,
  closeLabel = 'Close',
  placement = 'start',
  size = 'xs',
  header,
  footer,
  dividers = true,
}: DrawerProps) {
  const styles = drawerRecipe.raw({ placement });

  return (
    <Modal.Root open={open} onOpenChange={(nextOpen) => onOpenChange(nextOpen)} size={size}>
      <Modal.Portal>
        <Modal.Backdrop css={styles.backdrop}>
          <Modal.Content id={id} aria-label={ariaLabel} css={styles.content}>
            {header && <Modal.Header css={styles.header}>{header}</Modal.Header>}
            {header && dividers && <Divider />}
            <Modal.Body>{children}</Modal.Body>
            {footer && dividers && <Divider />}
            {footer && <Modal.Footer>{footer}</Modal.Footer>}
            <Modal.CloseButton css={styles.close}>
              <CloseButton label={closeLabel} title={closeLabel} />
            </Modal.CloseButton>
          </Modal.Content>
        </Modal.Backdrop>
      </Modal.Portal>
    </Modal.Root>
  );
}
